import { render, staticRenderFns } from "./ReadingDefinitionList.vue?vue&type=template&id=52f5756e&scoped=true&"
import script from "./ReadingDefinitionList.vue?vue&type=script&lang=ts&"
export * from "./ReadingDefinitionList.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingDefinitionList.vue?vue&type=style&index=0&id=52f5756e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5756e",
  null
  
)

export default component.exports